import React from 'react'

import { Link, useHistory } from 'react-router-dom'

import { Form } from '@unform/web'
import { FiLock, FiMail } from 'react-icons/fi'
import { Background, Container, Content, Transition } from './styles'

import * as Yup from 'yup'

// import paggueLogo from '@modules/users/assets/paggue.png'

import Button from '@shared/components/Button'
import { Input } from '@shared/components/Form'
import getValidationErrors from '@shared/utils/getValidationErrors'

import { useAuth } from '@shared/hooks/auth'
import { useToast } from '@shared/hooks/toast'
import { Line } from '@shared/components/Layout'

const SignIn = () => {
  const history = useHistory()

  const formRef = React.useRef(null)

  const { user: isSigned, signIn } = useAuth()

  const { addToast } = useToast()

  const [isLoading, setIsLoading] = React.useState(false)

  React.useEffect(
    function redirectToModulesOnSignIn () {
      if (isSigned) {
        history.push('/modules')
      }
    },
    [history, isSigned]
  )

  const handleLogin = React.useCallback(async (formData) => {
    try {
      setIsLoading(true)

      formRef.current?.setErrors({})

      const schema = Yup.object().shape({
        email: Yup.string()
          .required('Email obrigatório')
          .email('Digite um e-mail válido'),
        password: Yup.string()
          .required('Senha obrigatória')
      })

      await schema.validate(formData, { abortEarly: false })

      await signIn(formData)

      history.push('/modules')
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        formRef.current?.setErrors(
          getValidationErrors(error)
        )
      } else {
        console.error(error)
        addToast({
          type: 'error',
          title: 'Erro na autenticação!',
          description: 'Não foi possível fazer login. Verifique seu e-mail e senha.'
        })
      }
    } finally {
      setIsLoading(false)
    }
  }, [history, signIn, addToast])

  return (
    <Container>
      <Transition>
        <Content>
          <h1 className="login-form__title">Entrar</h1>

          <Form ref={formRef} className="login-form" onSubmit={handleLogin}>
            <Line />

            <Input
              name="email"
              type="email"
              icon={FiMail}
              placeholder="E-mail"
            />

            <Input
              name="password"
              type="password"
              icon={FiLock}
              placeholder="Senha"
            />

            <Button loading={isLoading} size="large" nativeType="submit" full>
              Entrar
            </Button>

            <Link className="login-form__recover-pass" to="/forgot-password">
              Esqueci minha senha
            </Link>
          </Form>

          {/* <Link className="create-account" to="/signup">
            <FiLogIn />
            Criar Uma Conta
          </Link> */}
        </Content>
      </Transition>
      <Background />
    </Container>
  )
}

export default SignIn
